import React from 'react';
import { Button } from './button';
import { Clock, MapPin, TrendingUp } from 'lucide-react';

export const ClosingSection = ({ onApplyClick }) => {
  const opportunityImages = [
    {
      src: "https://customer-assets.emergentagent.com/job_agi-layer/artifacts/o1z14yph_file_00000000a1a461f496d7718a660afe87.png",
      alt: "Limited Franchise Opportunities Available",
      title: "Limited Time",
      subtitle: "Exclusive territories filling fast",
      icon: Clock
    },
    {
      src: "https://customer-assets.emergentagent.com/job_agi-layer/artifacts/wqiuu2kl_file_00000000b508620a84cc01917a6c4cd8.png", 
      alt: "Be Your Own Boss - Franchise Opportunity",
      title: "Prime Locations",
      subtitle: "Best territories still available",
      icon: MapPin
    },
    {
      src: "https://customer-assets.emergentagent.com/job_agi-layer/artifacts/8pdtrmva_file_0000000063a4620ab5a2115c4da321b4.png",
      alt: "Proven Salon Business Model",
      title: "Proven Success", 
      subtitle: "Join our growing success network",
      icon: TrendingUp
    }
  ];

  return (
    <section className="py-24 bg-accent-primary text-white relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 bg-gradient-to-r from-accent-primary to-accent-primary/90"></div>
      <div className="absolute top-0 right-0 w-1/3 h-full bg-white/5 transform skew-x-12 translate-x-1/4"></div>
      
      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
        <div className="max-w-4xl mx-auto">
          {/* Franchise Opportunities Header */}
          <div className="bg-white border-2 border-accent-primary rounded-2xl p-6 mb-8 shadow-lg">
            <h2 className="text-4xl md:text-5xl font-bold text-accent-primary text-center">
              Limited Franchise Opportunities in UK and Europe
            </h2>
          </div>
          
          <p className="text-xl md:text-2xl mb-8 opacity-90 leading-relaxed">
            Don't Miss Out on This Exclusive Opportunity
          </p>
          
          {/* Banner */}
          <div className="bg-white border-2 border-accent-primary rounded-2xl p-6 mb-12 shadow-lg">
            <h3 className="text-3xl font-bold text-accent-primary text-center">
              "There's more to adding hair!"
            </h3>
          </div>
          
          {/* Professional Marketing Images */}
          <div className="grid md:grid-cols-3 gap-8 mb-12">
            {opportunityImages.map((opportunity, index) => (
              <div key={index} className="opportunity-image-card group">
                <div className="mb-6 transform group-hover:scale-105 transition-transform duration-300">
                  <img 
                    src={opportunity.src}
                    alt={opportunity.alt}
                    className="w-full h-auto rounded-2xl shadow-2xl border-4 border-white/20"
                  />
                </div>
                <div className="urgency-point text-center">
                  <opportunity.icon className="w-12 h-12 mx-auto mb-4 opacity-80" />
                  <h3 className="text-lg font-semibold mb-2">{opportunity.title}</h3>
                  <p className="text-white/80">{opportunity.subtitle}</p>
                </div>
              </div>
            ))}
          </div>
          
          {/* UK Regional Map */}
          <div className="mb-12">
            <div className="max-w-3xl mx-auto text-center">
              <h3 className="text-2xl font-bold mb-6 text-white">
                Available Franchise Regions
              </h3>
              <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                <img 
                  src="https://customer-assets.emergentagent.com/job_hair-opportunity/artifacts/nzmw8l0a_Hair%20extensions%20franchise%20launch%20regional%20map%20.gif"
                  alt="Hair Extensions Franchise Launch Regional Map - Available UK Regions"
                  className="w-full h-auto rounded-2xl shadow-2xl border-2 border-white/30 max-w-2xl mx-auto"
                />
                <p className="text-white/90 mt-4 text-lg">
                  Secure your exclusive territory today!
                </p>
              </div>
            </div>
          </div>
          
          <Button 
            onClick={onApplyClick}
            size="lg"
            className="bg-white border-2 border-white text-accent-primary hover:bg-accent-primary hover:text-white text-xl px-12 py-4 rounded-full shadow-2xl hover:shadow-3xl transition-all duration-300 font-semibold"
          >
            Apply Now to Secure Your Spot
          </Button>
          
          <p className="text-sm mt-6 opacity-70">
            Free consultation • No obligation • Quick response
          </p>
        </div>
      </div>
    </section>
  );
};